<template>
  <div class="OrderDetails">
    <div class="details_case">
      <div class="case-title">
        <img class="case-title_icon" src="@/assets/images/icon_lb@2x.png" alt />
        <div class="case-title_max">订单基本信息</div>
        <div class="right">
          <div class="table_storeType2">
            <div>现场付款</div>
          </div>
        </div>
      </div>
    </div>
    <div class="details_section">
      <div>
        <span>订单编号：</span>
        <span>{{ pageShowInfo.sellOrderNo }}</span>
      </div>
      <div>
        <span>订单状态：</span>
        <span>{{ pageShowInfo.state == '01' ? '待付款' : pageShowInfo.state == '02' ? '待收货' : pageShowInfo.state == '03' ?
          '已完成' : '已取消' }}</span>
        <span v-if="pageShowInfo.state == '01'" style="color: #FF0000;margin-left: 10px;">({{ pageShowInfo.autoTimeoutCancelTime }}后自动取消)</span>
      </div>
      <div>
        <span>下单时间：</span>
        <span>{{ pageShowInfo.orderTime }}</span>
      </div>
    </div>
    <div class="details_case">
      <div class="case-title">
        <img class="case-title_icon" src="@/assets/images/polpetuo.png" alt />
        <div class="case-title_max">客户信息</div>
        <div class="right">
          <div :class="pageShowInfo.deliveryType == '01' ? 'smType' : 'zitiType'">
            <div>{{ pageShowInfo.deliveryType == '01' ? '到店自提' : '送货上门' }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="user_styl">
      <div class="us_left">
        <img :src="pageShowInfo.createHeadImg" alt="">
        <span>用户手机号：</span>
        <span>{{ pageShowInfo.createUserPhone }}</span>
      </div>
      <div v-if="pageShowInfo.deliveryType == '01'">
        <span>到店自提联系人：</span>
        <span>{{ pageShowInfo.named }}-{{ pageShowInfo.contact }}</span>
      </div>
      <div v-else>
        <span>送货上门地址：</span>
        <span style="margin-right: 10px;">{{ pageShowInfo.named }}-{{ pageShowInfo.contact }}</span>
        <span>{{ pageShowInfo.userAddress }}</span>
      </div>
      <div>
        <span>顾客留言：</span>
        <span style="margin-right: 10px;">{{ pageShowInfo.remark||"--" }}</span>
      </div>
    </div>
    <div class="details_case">
      <div class="case-title">
        <img class="case-title_icon" src="@/assets/images/icon_shjjxx.png" alt />
        <div class="case-title_max">回收信息</div>
        <div class="shagnp_left">
          <span>{{ productViews[0].productName }}</span>
        </div>
      </div>
    </div>
    <!-- 回收信息 -->
    <div class="details_table">
      <el-table ref="tableGroup" :highlight-current-row="true" stripe :data="productViews" size="small" border
        style="width: 100%">
        <el-table-column prop="productCode" label="商品编号" align="center">
        </el-table-column>
        <el-table-column prop="imageList" label="旧机图片" align="center">
          <template slot-scope="{ row }">
            <img v-if="row.imageList" style="cursor: pointer;" :src="row.imageList[0].smallImg" alt=""
              @click="staffDia(row)">
            <img v-else style="cursor: pointer;" src="http://img.fanxinghuishou.cn/20230418/075263776.png" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="machineName" label="机型名称" align="center">
        </el-table-column>
        <el-table-column prop="imei" label="旧机串号" align="center">
        </el-table-column>
        <el-table-column prop="cost	" label="成本价" align="center">
          <template slot-scope="{ row }">
            <span>￥{{ row.cost || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="typeName" label="商品分类" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.typeName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="catalog" label="手机类型" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.catalog == '00' ? "优品机" : row.catalog == '01' ? "演示机" : "资源机" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="brandName" label="商品品牌" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.brandName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="named" label="质检报告" align="center">
          <template slot-scope="{ row }">
            <span style="cursor: pointer;text-decoration:underline;color:#0981ff;" @click="checkReport(row)">查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="stockStoreName" label="库存位置" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.stockStoreName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryType" label="是否可调店" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.isTransferStore ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <div class="action_style">
              <el-button size="small" type="text" round @click="reportDetal(row)">商品详情</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="details_double">
      <div class="left">
        <div class="details_case">
          <div class="case-title">
            <img class="case-title_icon" src="@/assets/images/icon_dddt.png" alt />
            <div class="case-title_max">订单动态</div>
          </div>
        </div>
      </div>
      <div style="padding: 0 20px 20px">
        <div class="orderStatus">
          <div class="state_content">
            <div class="color_333 font_18 sept_style">
              <div>下单</div>
              <div class="line" v-if="pageShowInfo.state!=='01'"></div>
              <div class="line_y" v-if="pageShowInfo.state!=='01'"></div>
            </div>
            <div class="sc_rotail">
              <span>下单时间：</span>
              <span>{{ pageShowInfo.orderTime || "--" }}</span>
            </div>
            <div class="sc_rotail">
              <span>配送方式：</span>
              <span>{{ pageShowInfo.deliveryType == '01' ? '到店自提' : '送货上门' }}</span>
            </div>
            <div class="sc_rotail">
              <span>{{ pageShowInfo.deliveryType == '01' ? '预约门店' : '送货门店' }} ：</span>
              <span>{{ pageShowInfo.storeName || "--" }}</span>
            </div>
            <div class="sc_rotail">
              <span>接单人：</span>
              <span style="margin-right: 10px;">{{ pageShowInfo.receiveStaffName }}-{{ pageShowInfo.receiveStaffMobile
              }}</span>
              <el-button type="success" size="small">{{ pageShowInfo.receiveStaffIsMajor
                ? "创建人"
                : pageShowInfo.receiveStaffType == "01"
                  ? "子账号"
                  : pageShowInfo.receiveStaffType == "02"
                    ? "总监"
                    : pageShowInfo.receiveStaffType == "03"
                      ? "店长"
                      : "店员" }}</el-button>
            </div>
            <div class="sc_rotail" v-if="pageShowInfo.deliveryType == '01'">
              <span>预约时间：</span>
              <span>{{ pageShowInfo.arriveTimeRegion || "--" }}</span>
            </div>
          </div>
          <div class="state_content" v-if="pageShowInfo.state!=='01'&&pageShowInfo.state!=='20'">
            <div class="color_333 font_18 sept_style">
              <div>付款</div>
              <div class="line" v-if="pageShowInfo.state=='03'"></div>
              <div class="line_y" v-if="pageShowInfo.state=='03'"></div>
            </div>
            <div class="sc_rotail">
              <span>收款时间：</span>
              <span>{{ pageShowInfo.payTime || "--" }}</span>
            </div>
            <div class="sc_rotail">
              <span>支付方式：</span>
              <span>线下付款</span>
            </div>
            <div class="sc_rotail">
              <span>收款店员：</span>
              <span style="margin-right: 10px;">{{ pageShowInfo.paymentStaffName }}-{{ pageShowInfo.paymentStaffMobile
              }}</span>
              <el-button type="success" size="small">{{ pageShowInfo.paymentStaffIsMajor
                ? "创建人"
                : pageShowInfo.paymentStaffType == "01"
                  ? "子账号"
                  : pageShowInfo.paymentStaffType == "02"
                    ? "总监"
                    : pageShowInfo.paymentStaffType == "03"
                      ? "店长"
                      : "店员" }}</el-button>
            </div>
            <div class="sc_rotail">
              <span>收款凭证：</span>
              <div class="fukuan">
                <el-button type="text" size="small" @click="vewImg(pageShowInfo.paymentProof)">查看</el-button>
              </div>
            </div>
            <div class="sc_rotailcopy">
              <span>收款备注：</span>
              <div style="width: 300px; line-height: 19px;">{{ pageShowInfo.paymentRemark ||"--"}}</div>
            </div>
          </div>
          <div class="state_content" v-if="pageShowInfo.state!=='01'&&pageShowInfo.state!=='20'&&pageShowInfo.state==='03'">
            <div class="color_333 font_18 sept_style">
              <div>收货</div>
            </div>
            <div class="sc_rotail">
              <span>收货时间：</span>
              <span>{{ pageShowInfo.finishTime || "--" }}</span>
            </div>
            <div class="sc_rotail">
              <span>提货店员：</span>
              <span style="margin-right: 10px;">{{ pageShowInfo.finishStaffName }}-{{ pageShowInfo.finishStaffMobile
              }}</span>
              <el-button type="success" size="small">{{ pageShowInfo.finishStaffIsMajor
                ? "创建人"
                : pageShowInfo.finishStaffType == "01"
                  ? "子账号"
                  : pageShowInfo.finishStaffType == "02"
                    ? "总监"
                    : pageShowInfo.finishStaffType == "03"
                      ? "店长"
                      : "店员" }}</el-button>
            </div>
          </div>
          <div class="state_content" v-if="pageShowInfo.state=='20'">
            <div class="color_333 font_18 sept_style">
              <div>取消</div>
            </div>
            <div class="sc_rotail">
              <span>取消时间：</span>
              <span>{{ pageShowInfo.cancelTime || "--" }}</span>
            </div>
            <div class="sc_rotail">
              <span>取消类型：</span>
              <span>{{ pageShowInfo.cancelType === '01' ? "用户主动取消" : pageShowInfo.cancelType === '02' ? "店员取消" : "超时自动取消" }}</span>
              <div class="fukuan" style="margin-left: 10px;">
                <el-button type="text" size="small" @click="seeCustomerInfo">查看原因</el-button>
              </div>
            </div>
            <div class="sc_rotail">
              <span>取消人：</span>
              <span style="margin-right: 10px;">{{ pageShowInfo.cancelStaffName }}-{{ pageShowInfo.cancelStaffMobile
              }}</span>
              <el-button v-if="pageShowInfo.cancelStaffName" type="success" size="small">{{ pageShowInfo.cancelStaffIsMajor
                ? "创建人"
                : pageShowInfo.cancelStaffType == "01"
                  ? "子账号"
                  : pageShowInfo.cancelStaffType == "02"
                    ? "总监"
                    : pageShowInfo.cancelStaffType == "03"
                      ? "店长"
                      : "店员" }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 查看图片 -->
    <el-dialog :close-on-click-modal="false" :width="`${800}px`" title="查看旧机图片" :visible="imgShow" @close="imgClose"
      top="5%">
      <div class="img-box">
        <div class="img-tips-box">
          <div class="img-tips" :class="imgShowOnly ? 'img-tips-choose' : 'img-tips-default'">
            旧机图片
          </div>
        </div>
        <div class="img-show">
          <div class="imgs-num" v-if="DialogImgList.length > 0">
            {{ imgShowIndex + 1 }}/{{ DialogImgList.length }}
          </div>
          <div class="block">
            <viewer :images="DialogImgList">
              <el-carousel trigger="click" height="80vh" @change="getindex">
                <el-carousel-item v-for="(item, index) in DialogImgList" :key="index">
                  <div class="sec_img">
                    <img :src="item.originalImg" alt="" />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </viewer>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 质检报告 -->
    <el-dialog title="质检报告" :visible.sync="nonsalableVisible" :close-on-click-modal="false" width="800px"
      @closed="nonsalableVisible = false">
      <div class="re_top" >
        <div class="reline"></div>
        <span>基本信息</span>
      </div>
      <div class="re_content">
        <div class="rec_revol" v-for="(i,index) in dereportList.bases" :key="index">
          <span>{{ i.label }}：</span>
          <span v-if="i.layout=='01'">
            <span v-for="ivue in i.values" :key="ivue.value"  style="color: rgb(9, 129, 255);">
           <span v-if="ivue.isSelected"> {{ ivue.value }}</span>
          </span>
          </span>
           <span v-else style="color: rgb(9, 129, 255);">{{ i.values[0].value }}</span>
        </div>
      </div>
      <div class="re_top">
        <div class="reline"></div>
        <span>成色情况</span>
      </div>
      <div class="re_content">
        <div class="rec_revol" v-for="(i,index) in dereportList.fineness" :key="index">
          <span>{{ i.label }}：</span>
          <span v-for="ivue in i.values" :key="ivue.value"  style="color: rgb(9, 129, 255);">
           <span v-if="ivue.isSelected"> {{ ivue.value }}</span>
          </span>
          <!-- <span v-else style="color: rgb(255, 0, 0);">{{ i.values[0].value }}</span> -->
        </div>
      </div>
      <div class="re_top">
        <div class="reline"></div>
        <span>功能情况</span>
      </div>
      <div class="re_content">
        <div class="rec_revol" v-for="(i,index) in dereportList.func" :key="index">
          <span>{{ i.label }}：</span>
          <!-- <span v-if="i.values[0].isSelected" style="color: rgb(9, 129, 255);">{{ i.values[0].value }}</span> -->
          <span v-for="ivue in i.values" :key="ivue.value"  style="color: rgb(9, 129, 255);">
           <span v-if="ivue.isSelected"> {{ ivue.value }}</span>
          </span>
          <!-- <span v-else style="color: rgb(255, 0, 0);">{{ i.values[0].value }}</span> -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small"  @click="nonsalableVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-image-viewer :zIndex="99999" v-if="showViewer" :on-close="() => {
        showViewer = false;
      }
      " :url-list="imgList" />
    <el-dialog title="取消原因" :visible.sync="customerInfoShow" :close-on-click-modal="false" width="500px">
      <div style="font-size:14px;color:#333333;padding-bottom:21px">
        <div class="flex" style="margin-bottom:20px">
          <span>取消类型：</span><span style="color:#666666;">{{ pageShowInfo.cancelType === '01' ? "用户主动取消" : pageShowInfo.cancelType === '02' ? "店员取消" : "超时自动取消" }}</span>
        </div>
        <div class="flex" style="margin-bottom:20px" v-if="pageShowInfo.cancelType !== '01'">
          <span>操作人：</span><span style="color:#666666;">{{ pageShowInfo.cancelStaffName }}-{{ pageShowInfo.cancelStaffMobile||"--" }}</span>
        </div>
        <!-- <div class="flex" style="margin-bottom:20px" v-if="pageShowInfo.cancelType === '03'">
          <span>取消时间：</span><span style="color:#666666;">{{ pageShowInfo.autoTimeoutCancelTime }}</span>
        </div> -->
        <div class="flex" style="margin-bottom:20px">
          <span>取消时间：</span><span style="color:#666666;">{{ pageShowInfo.cancelTime ||"--"}}</span>
        </div>
        <div class="flex" style="margin-bottom:20px">
          <p style="min-width: 70px;">取消原因：</p><span style="color:#666666;">{{ pageShowInfo.cancelRemark }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click.native="customerInfoShow = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import _api from "@/utils/request";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  name: "OrderDetails",
  components: { ElImageViewer },
  data() {
    return {
      dialogTitle: "",
      dereportList:{},
      productViews: [],
      dialogVisibleOrder: false,
      customerInfoShow: false,
      orderNo: "",
      tabledata: [],
      faultsList: [],
      DialogImgList: [[], []],
      imgList: [],
      showViewer: false,
      imgShowIndex: 0,
      imgShow: false,
      imgIndex: 0,
      dialogDiff: {},
      // 自增放入页面的数据(经过处理后)
      pageShowInfo: {},
      // 报价回收商列表
      storeList: [],
      nonsalableVisible:false,
    };
  },
  created() {
    this.getpremiumInfo()
  },
  methods: {
     //质检报告
     checkReport(row) {
      _api.delireport({ productCode: row.productCode }).then(res => {
        if (res.code == 1) {
          this.dereportList = res.data
          this.nonsalableVisible=true
        }
      })
    },
    //商品详情
    reportDetal(row) {
      let lybl = this.$router.resolve(
        {
          path: '/onlinSalemachines/productList',
          query: {
            productCode: row.productCode
          }
        })

      window.open(lybl.href, '_blank');
    },
    //查看图片
    staffDia(row) {
      if (row.imageList) {
        this.imgShow = true;
        this.DialogImgList = row.imageList;
        console.log(this.DialogImgList);
      }
    },
    imgClose() {
      console.log(1);
      this.imgShow = false;
      this.imgList = [];
    },
    // -撤销收货详情
    getpremiumInfo() {
      _api.premiumInfo({ sellOrderNo: this.$route.query.sellOrderNo }).then(res => {
        this.pageShowInfo = res.data
        this.productViews = res.data.productViews
      })
    },
    chooseImages(e) {
      if (e == 0) {
        this.imgIndex = 0;
        this.imgShow = true;
      }
      if (e == 1) {
        this.imgIndex = 1;
        this.imgShow = false;
      }
    },
    getindex(e) {
      console.log(e);
      this.imgShowIndex = e;
    },
    vewImg(obj) {
      this.imgList = [];
      this.showViewer = true;
      if (obj) {
        this.imgList.push(obj);
      }
    },
    //取消原因
    seeCustomerInfo() {
      this.customerInfoShow = true;
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.re_top {
  display: flex;
  align-items: center;

  .reline {
    width: 4px;
    height: 16px;
    background: #4966d2;
    margin-bottom: 0px;
    margin-right: 10px;
  }
}

.re_content {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  .rec_revol {
    width: 370px;
    height: 40px;
    background-color: #e4ecfd;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 10px;
    color: #333333;
    font-size: 14px;
    margin-right: 10px;
    word-break: break-all;
  }
}
.sept_style {
  font-weight: 600;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.action_style {
  display: flex;
  align-items: center;
  justify-content: center;

  /deep/.el-button {
    text-decoration: underline;
    margin: 0;
  }
}

.orderStatus {
  display: flex;
  align-items: center;
  background: #f5f6fa;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 10px;

  .state_content {
    height: 230px;

    .sc_rotail {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin-top: 15px;

      .fukuan {
        /deep/.el-button {
          text-decoration: underline;
        }
      }
    }
    .sc_rotailcopy {
      display: flex;
      // align-items: center;
      font-size: 14px;
      margin-top: 15px;

      .fukuan {
        /deep/.el-button {
          text-decoration: underline;
        }
      }
    }
  }

  .line {
    width: 250px;
    height: 2px;
    background: #0981ff;
    margin-left: 10px;
  }

  .line_y {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    background: #0981ff;
    margin-right: 10px;
  }
}

.shagnp_left {
  margin-left: 40px;
  font-weight: bold;
  color: #333333;
  font-size: 18px;
  height: 17px;
  line-height: 17px;
  margin-left: 10px;
  font-family: FZLanTingHei-B-GBK;
}

.OrderDetails {
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;

  .details_bottom {
    display: flex;
    flex-direction: column;

    div {
      width: 50%;
    }
  }

  .details_case {
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .case-title {
      margin: 20px;
      display: flex;
      align-items: center;

      .case-title_icon {
        width: 20px;
        height: 20px;
      }

      .case-title_max {
        min-width: 72px;
        font-weight: bold;
        color: #333333;
        font-size: 18px;
        height: 17px;
        line-height: 17px;
        margin-left: 10px;
        font-family: FZLanTingHei-B-GBK;
      }

      .left {
        display: flex;
        position: relative;
        // justify-content: space-between;
        flex-wrap: wrap;

        div {
          margin-left: 15px;

          >div {
            width: 32px;
            height: 22px;
            background: #21d8c2;
            border-radius: 3px 11px 11px 3px;
            color: white;
            line-height: 22px;
            position: absolute;
            text-align: center;
            top: 0;
            left: -5px;
            margin-right: 10px;
          }

          >span {
            font-family: FZLanTingHei-DB-GBK;
            font-size: 14px;
            font-weight: 400;
            color: #0981ff;
          }

          >input {
            border: none;
            background: none;
            color: #0981ff;
            padding: 0;
            width: 140px !important;
            font-size: 14px;
          }

          >.copy {
            height: 16px;
            display: inline-block;
            line-height: 16px;
            text-align: center;
            background: #0981ff;
            color: #fff;
            margin-left: 8px;
            border-radius: 4px;
            font-size: 12px;
            padding: 0 10px;
          }
        }
      }

      .right {
        display: flex;
        color: #fff;

        .rightTrue {
          width: max-content;
          padding: 5px 10px;
          font-size: 14px;
          background-color: #ff687b;
          margin-left: 10px;
          border-radius: 5px;
          text-align: center;
        }

        .table_storeType {
          margin-left: 20px;
          border-radius: 10px 10px 10px 0;
          background-color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid rgb(248, 50, 50);
          color: rgb(248, 50, 50);
          font-size: 12px;
          padding: 3px 5px;
        }

        .zitiType {
          margin-left: 20px;
          border-radius: 10px 10px 10px 0;
          background-color: #ff8800;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 12px;
          padding: 3px 5px;
        }

        .smType {
          margin-left: 20px;
          border-radius: 10px 10px 10px 0;
          background-color: #0981ff;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 12px;
          padding: 3px 5px;
        }




        .rightFalse {
          width: max-content;
          padding: 5px 10px;
          font-size: 14px;
          background-color: #ffaf29;
          margin-left: 10px;
          border-radius: 5px;
          text-align: center;
        }

        .rightMid {
          width: max-content;
          padding: 5px 10px;
          font-size: 14px;
          background-color: rgba(102, 204, 153, 1);
          margin-left: 10px;
          border-radius: 5px;
          text-align: center;

          &.online {
            background: #ff687a !important;
          }
        }
      }
    }
  }

  .details_section {
    background: #f5f6fa;
    border-radius: 10px;
    height: 126px;
    margin: 0 20px;

    &>div {
      padding: 20px 10px 15px 20px;
      height: 16px;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      line-height: 20px;

      span:not(:first-child) {
        color: rgb(77, 77, 77);
      }
    }
  }

  .details_table {
    margin: 0 20px;

    .remark {
      font-size: 12px;
      font-weight: 400;
      color: #ff8080;
      margin: 10px;
    }
  }

  .details_double {
    // height: 320px;
    justify-content: space-between;
    align-items: center;

    .left {
      width: 50%;
    }

    .details_double_item {
      display: flex;

      >.details_section_record {
        padding-top: 20px;
        background: #f5f6fa;
        border-radius: 10px;
        margin: 0 20px 20px;
        width: 50%;

        div {
          padding: 10px 10px 10px 20px;
          font-size: 16px;
          font-weight: 400;
          color: #999999;

          span:not(:first-child) {
            color: rgb(77, 77, 77);
          }
        }

        .details_tips {
          margin-left: 22px;
          padding: 0;
          background: #0981ff;
          color: #fff;
          height: 28px;
          box-sizing: border-box;
          width: 100px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .fault-box {
    color: #333333;
  }

  .faultBtn {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    padding: 10px 0;

    .faultBut_item {
      height: 40px;
      background-color: #e4ecfd;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 20px;
      margin-bottom: 10px;
      width: 240px;

      >span {
        color: #0099ff;
      }
    }

    .faultSystem_item {
      background-color: #e4ecfd;
      border-radius: 6px;
      padding: 10px;
      margin-bottom: 10px;
      width: 380px;

      >span {
        color: #0099ff;
      }
    }

    .oneline_item {
      width: 380px;
      min-height: 40px;
      background: rgba(228, 236, 253, 0.9);
      border-radius: 6px;
      display: flex;
      align-items: center;
      padding: 10px 18px;
      box-sizing: border-box;
      margin-bottom: 20px;
      text-align: justify;
    }
  }

  .tableBtn {
    color: #0981ff;
    cursor: pointer;
  }

  .sec_img {
    width: 20vw;
    height: 80vh;
    margin: auto;

    img {
      width: 20vw;
      height: 80vh;
      object-fit: contain;
    }
  }
}

.dialogDiff_double_item {
  display: flex;

  >.details_section {
    background: #fff;
    border-radius: 10px;
    height: 216px;
    margin: 0 20px 0 0;
    width: 50%;

    div {
      padding: 20px 10px 15px 20px;
      height: 16px;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      line-height: 20px;

      span:not(:first-child) {
        color: rgb(77, 77, 77);
      }
    }

    .details_tips {
      padding: 5px 10px;
      background: #0981ff;
      color: #fff;
      height: 28px;
      box-sizing: border-box;
      width: 100px;
      border-radius: 10px;
    }
  }
}

.user_styl {
  display: flex;
  align-items: center;
  background: #f5f6fa;
  border-radius: 10px;
  height: 100px;
  margin: 0 20px;

  div {
    padding: 20px 10px 15px 20px;
    font-size: 16px;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
  }

  .us_left {
    display: flex;
    align-items: center;

    img {
      margin-right: 10px;
      width: 70px;
      height: 70px;
      border-radius: 50%;
    }
  }
}

.see-btn {
  color: #0981ff !important;
  cursor: pointer;
  text-decoration: underline;
}

.see-difference {
  color: #ff3300 !important;
  text-decoration: underline;
  cursor: pointer;
}

.money,
.money1 {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.money>div {
  color: #fff;
  margin-left: 5px;
  background: rgba(255, 102, 0, 1);
  border-radius: 10px;
  padding: 0px 10px;
}

.money1>div {
  color: #fff;
  margin-left: 5px;
  background: rgba(11, 130, 255, 1);
  border-radius: 10px;
  padding: 0px 10px;
}

.diff-imgs {
  width: 98px;
  height: 98px;
  margin-left: 10px;
}

.block-ml-10 {
  display: inline-block;
  margin-left: 10px;
}

.mb-10 {
  margin-bottom: 10px;
}

// 弹窗
.img-box {
  margin-bottom: 20px;

  // 图片
  .imgs-num {
    text-align: center;
    margin: 5px 0;
    font-weight: bold;
  }

  .img-tips-box {
    display: flex;
    width: max-content;
    height: 30px;
    border: 1px solid #0981ff;

    .img-tips {
      width: 80px;
      text-align: center;
      line-height: 30px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .img-tips-default {
      background: #fff;
      color: #0981ff;
    }

    .img-tips-choose {
      background: #0981ff;
      color: #fff;
    }
  }
}

.hidden-2 {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.isdeal {
  background: #ff687b;
  display: inline-block;
  width: max-content;
  padding: 0px 4px;
  font-size: 14px;
  margin: 0 auto;
  border-radius: 5px;
  color: #fff;
  text-align: center;
  margin-right: 5px;
}

.cancel-receipt-info {
  .details_tips {
    padding: 0;
    background: #0981ff;
    color: #fff;
    height: 28px;
    box-sizing: border-box;
    width: 100px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
  }
}

.fs-16 {
  font-size: 16px;
}

.fs-12 {
  font-size: 12px;
}

.flex {
  display: flex;
  align-items: center;
}

.flex-jb {
  display: flex;
  justify-content: space-between;
}

.flex-aa {
  display: flex;
  align-items: flex-start;
}

.flex1 {
  flex: 1;
}

.mt-20 {
  margin-top: 20px;
}

.mt-10 {
  margin-top: 10px;
}

.test-el-tag1 {
  background-color: #21d8c2 !important;
  border-color: #21d8c2 !important;
  color: white !important;
}

.test-el-tag2 {
  background-color: #ff687b !important;
  border-color: #ff687b !important;
  color: white !important;
}

.system_icon {
  font-size: 12px;
  width: max-content;
  padding: 0 6px;
  height: 16px;
  line-height: 16px;
  background: #21d8c2;
  border-radius: 11px 8px 8px 0px;
  color: #fff;
  margin-left: 10px;
}

.txt-base {
  color: #444cf0;
}

.flex {
  display: flex;
  align-items: center;
}

.one_line {
  box-sizing: border-box;
  padding: 0 40px;

  .one_line_item {
    margin-top: 10px;

    .one_line_item_title {
      position: relative;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      padding-left: 15px;
    }

    .one_line_item_title::after {
      position: absolute;
      content: " ";
      top: 0;
      bottom: 0;
      margin: auto;
      left: 0;
      width: 3px;
      height: 14px;
      background: #0981ff;
      border-radius: 2px;
    }

    .one_line_item_conent {
      margin-top: 10px;

      .one_line_item_conent_item {
        margin-right: 40px;
        font-size: 14px;

        .one_line_item_conent_item_box {
          padding: 0 5px;
          height: 20px;
          background: #f5f6fa;
          border-radius: 3px;
          line-height: 20px;
          margin-right: 10px;
        }
      }
    }
  }
}

.txt-red {
  color: #FF3300 !important;
}

.txt-green {
  color: #44d886 !important;
}

.table_storeType2 {
  border-radius: 10px 10px 10px 0;
  background-color: #fff;
  display: flex;
  margin-left: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid #0981ff;
  color: #0981ff;
  font-size: 12px;
  padding: 3px 5px;
}</style>
